import { render, staticRenderFns } from "./SideMenuItem.vue?vue&type=template&id=4089e1a9"
import script from "./SideMenuItem.vue?vue&type=script&lang=js"
export * from "./SideMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports